<template>
  <div
    v-if="Array.isArray(value) && value.length"
    class="infoBlock"
  >
    <div
      class="expandable"
      @click="toggleExpando"
    >
      <div
        :class="expandoClass"
        :data-automation="dataAutomation + '-count'"
      >
        {{ value.length }}
      </div>
      <div
        class="label"
        :data-automation="dataAutomation + '-label'"
      >
        {{ label }}
      </div>
    </div>
    <RelatedPackages
      v-if="expanded"
      :data-automation="dataAutomation"
      :packages="value"
    />
  </div>
</template>

<script>
import RelatedPackages from './RelatedPackages'

export default {
  name: 'InfoBlockPackageList',
  components: {
    RelatedPackages,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    dataAutomation: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: function () {
    return {
      expanded: false,
    }
  },
  computed: {
    expandoClass: function () {
      return this.expanded ? 'expando expanded' : 'expando collapsed'
    },
  },
  watch: {
    value: function (value) {
      this.expanded = false
    },
  },
  methods: {
    toggleExpando: function (event) {
      this.expanded = !this.expanded
    },
  },
}

</script>
